module.exports = __webpack_public_path__ + "static/fonts/PorscheNext-Regular.e01cf735.otf";